<template>
    <div style="height: 100%;">
            <van-nav-bar
            title="请假记录"
            left-text="返回"
            left-arrow
            @click-left="historyBack"
          />
    
    <el-table v-loading="querybutton"  size="mini" :data="staffRests" highlight-current-row height="calc(100% - 3rem)" ref="table5">
        <el-table-column prop="leavetypename" align="center" label="名称"></el-table-column>
        <el-table-column prop="fromdate" align="center" label="开始"></el-table-column>
        <el-table-column prop="todate" align="center" label="结束"></el-table-column>
        <el-table-column prop="todate" align="center" label="操作">
            <template slot-scope="scope">
                <el-button type="danger" size="mini" @click="updateStaffRestStatus(scope)">作废</el-button>
            </template>
        </el-table-column>
    </el-table>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                staffRests:[],
                querybutton:false,
                staffid:"",
            }
        },
        created:function () {
            this.staffid=this.$route.query.staffid;
            this.getStaffRestByStaff();
        },
        methods: {
            updateStaffRestStatus(scope){
                this.$dialog({
                    message:'您确定要作废该条记录吗',
                    showCancelButton:true,
                }).then(() => {
                    this.$post("hairwork/updateStaffRestStatus",{storeid:scope.row.storeid,sysbillid:scope.row.sysbillid,status:-1}).then(res=>{
                        this.querybutton=false;
                        if(res.sucess){
                            this.$message({
                                message: '作废成功',
                                type: 'success'
                            });
                            this.getStaffRestByStaff();
                        }
                        else{
                            this.$message({
                                message: res.message,
                                type: 'error'
                            });
                        }
                    });
                });
                
            },
            getStaffRestByStaff(){
                this.querybutton=true;
                this.$post("hairwork/getStaffRestByStaff",{staffid:this.staffid}).then(res=>{
                    this.querybutton=false;
                    if(res.sucess){
                        this.staffRests=res.object;
                    }
                    else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                });
            }
        }
    }
</script>    


// WEBPACK FOOTER //
// src/page/hair/staffrest.vue